export const BETA_LINK_URL = "https://4ng1awtt5c.execute-api.eu-west-1.amazonaws.com/dev/link";
export const BETA_VIEW_LINK_URL = "https://4ng1awtt5c.execute-api.eu-west-1.amazonaws.com/dev/viewlink";
export const BETA_VIEW_STATUS_URL = "https://4ng1awtt5c.execute-api.eu-west-1.amazonaws.com/dev/status";

export const VIEW_LINK_GENERATION_DELAY = 60_000;
export const VIEW_LINK_SESSION_CHECK_DELAY = 60_000;

export const FAST_SRV = "fast/user";